import NBType, { InferType } from '@netbase/nb-type'
import Errno from '../enums/Errno'
import ThemeStatusType from '../enums/ThemeStatusType'

const ThemeStatusSchema = NBType.object().shape('ThemeStatusSchema', {
  /* @prop */
  builder: NBType.string().nullable(),
  /* @prop */
  error: NBType.enum(Errno).nullable(),
  /* @prop */
  type: NBType.enum(ThemeStatusType)
  /* END */
})
export default ThemeStatusSchema
export type ThemeStatus = InferType<typeof ThemeStatusSchema>
// RESERVE BELOW
